import { useEffect } from 'react';
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  TextField
} from '@mui/material';
import { useTheme } from '@mui/material/styles';
import { useDispatch, useSelector } from 'react-redux';
import Title from '../../components/Title';
import { InputChangeEvent } from '../../resources/utils';
import {
  clearScooterType,
  createScooterTypeAsync,
  getScooterTypesAsync,
  selectScooterTypes,
  setScooterType,
  updateScooterTypeAsync
} from '../../redux/slices/scooterTypesSlice';
import { ScooterType } from '../../resources/types/scooterTypesTypes';

interface Props {
  open: boolean;
  scooterType?: ScooterType;
  onClose: () => void;
}

const ScooterTypeModal = (props: Props) => {
  const { open, scooterType: editScooterType, onClose } = props;
  const theme = useTheme();
  const dispatch = useDispatch();

  const { scooterType } = useSelector(selectScooterTypes);

  useEffect(() => {
    if (open && editScooterType) {
      dispatch(setScooterType(editScooterType));
    } else if (!open) {
      dispatch(clearScooterType());
    }
  }, [dispatch, open, editScooterType]);

  const handleChange = (e: InputChangeEvent) => {
    dispatch(setScooterType({ [e.target.name]: e.target.value }));
  };

  const handleSubmit = async () => {
    try {
      if (scooterType._id) {
        await dispatch(updateScooterTypeAsync());
      } else {
        await dispatch(createScooterTypeAsync());
      }
      dispatch(getScooterTypesAsync());
      onClose();
    } catch (error) {
      console.error('Error saving scooter type:', error);
    }
  };

  return (
    <Dialog open={open} onClose={onClose} maxWidth='sm' fullWidth>
      <DialogTitle>
        <Title>{scooterType._id ? 'Редагувати тип' : 'Створити тип'}</Title>
      </DialogTitle>
      <DialogContent>
        <TextField
          fullWidth
          label='Назва типу'
          name='name'
          value={scooterType.name || ''}
          onChange={handleChange}
          margin='normal'
          required
        />
      </DialogContent>
      <DialogActions>
        <Button
          onClick={onClose}
          sx={{
            bgcolor: theme.palette.mode === 'light' ? '#F5F5F5' : '#424242',
            color: theme.palette.mode === 'light' ? '#000' : '#FFF',
            '&:hover': {
              bgcolor: theme.palette.mode === 'light' ? '#E0E0E0' : '#3A3A3A'
            }
          }}
        >
          Скасувати
        </Button>
        <Button
          onClick={handleSubmit}
          variant='contained'
          color='primary'
          disabled={!scooterType.name?.trim()}
        >
          Зберегти
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ScooterTypeModal;
